import "components/jiffy/product-details-favorite/product-details-favorite-sign-in/product-details-favorite-sign-in";
import initToggle from "components/jiffy/digital-assets/digital-assets-my-library-toggle/digital-assets-my-library-toggle";
import initNotification from "components/jiffy/digital-assets/digital-assets-my-library-notification/digital-assets-my-library-notification";

export default () => {
  const notification = initNotification();
  const toggle = initToggle({
    saveLibraryCallback: isActive => notification.updateNotification(isActive)
  });

  toggle.init();
};
